import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const PagoCancelado = () => {
  const { code } = useParams();
  const navigate = useNavigate();

  return (
    <motion.div
	      initial={{ y: "100%", opacity: 0 }}
	      animate={{ y: 0, opacity: 1 }}
	      exit={{ y: "100%", opacity: 0 }}
	      transition={{ duration: 0.7, ease: "easeInOut" }}
    	>
    <div className="app-container" style={{ textAlign: "center", padding: 40 }}>
      <img src="/assets/images/cancelled.svg" alt="Cancelado" width={100} style={{ marginBottom: 20 }} />
      <h2>Pago cancelado</h2>
      <p>Tu transacción no fue completada.</p>
      <p>Si fue un error, podés intentarlo nuevamente.</p>

      <button className="subscription-button" onClick={() => navigate("/perfil")} style={{ marginTop: 30 }}>
        Volver al perfil
      </button>
    </div>
    </motion.div>
  );
};

export default PagoCancelado;
